module.exports = __webpack_public_path__ + "static/media/testen-er-ferdig.5d5878c9.mp3";